<template>
    <CRow>
      <CCol col="12" xl="12">
        <CCard>
          <CCardHeader>
            Edit Promotion
          </CCardHeader>
          <CCardBody>
            <CForm v-if="form">
              <CInput label="Name" :value.sync="form.name" placeholder="Promotion Name" />
              <CTextarea label="Description" :value.sync="form.description" placeholder="Promotion Description" />

              <div v-if="$store.state.user.menu_array.includes('csr') || $store.state.user.menu_array.includes('csr_admin')" style="padding-bottom:15px;">
                <label>Disabled?</label>
                <CButton size="sm" @click="form.disabled = true" style="margin-left:5px;" :color="form.disabled ? 'success' : 'outline-success'">Yes</CButton>
                <CButton size="sm" @click="form.disabled = false" style="margin-left:5px;" :color="!form.disabled ? 'danger': 'outline-danger'">No</CButton>
              </div>

              <CInput label="Min Quantity Required" type="number" :value.sync="form.min_quantity_required" />
  
              <div style="padding-bottom:15px;">
                <label>Discount Type</label>
                <v-select v-model="form.discount_type" :options="discountTypes" placeholder="Select Type" />
              </div>

              <div v-if="form.discount_type === 'shipping_discount' && shipViaOptions" style="padding-bottom:15px;">
                <label>Ship Via Type</label>
                <!-- <v-select v-model="form.ship_to_type" :options="shipViaOptions" placeholder="Select Type" /> -->
                <v-select
                    v-model="form.ship_to_type"
                    v-if="shipViaOptions"
                    :options="shipViaOptions"
                    placeholder="Select Ship Via"
                    label="ship_via_text"
                >
                  <template slot="option" slot-scope="option">
                    {{option['ship_via_code']}} - {{option['ship_via_text']}}
                  </template>
                  <template slot="selected-option" slot-scope="option">
                    {{option.ship_via_code}} - {{option.ship_via_text}}
                  </template>
                </v-select>
              </div>
  
              <CInput label="Discount Value" type="number" :value.sync="form.discount_value" />

              <div style="padding-bottom:15px;">
                <label>Product Classes (leave empty for all)</label>
                <v-select v-model="form.product_classes" :options="productClasses" multiple placeholder="Select Product Class" />
              </div>

              <div style="padding-bottom:15px;" v-if="!form.applies_to_current_order">
                <label>Product Classes Allowed On New Promo Order (leave empty for all)</label>
                <v-select v-model="form.bonus_product_classes" :options="productClasses" multiple placeholder="Select Product Class" />
              </div>

              <div style="padding-bottom:15px;">
                <label>Technique Types (leave empty for all)</label>
                <v-select v-model="form.technique_types" :options="techniqueTypeOptions" multiple placeholder="Select Technique Types" />
              </div>

              <div style="padding-bottom:15px;">
                <label>Techniques (leave empty for all)</label>
                <v-select
                  v-model="form.technique_ids"
                  :options="techniques"
                  label="technique_name"
                  multiple
                  placeholder="Select Techniques"
                  :get-option-label="techniqueOptionLabel"
                />
              </div>

              <div style="padding-bottom:15px;">
                <label>User Types (leave empty for all)</label>
                <multiselect v-model="form.user_types" :options="userTypeOptions" :multiple="true" />
              </div>
  
              <div style="padding-bottom:15px;">
                <label>Applies To Current Order?</label>
                <CButton size="sm" @click="form.applies_to_current_order = true" style="margin-left:5px;" :color="form.applies_to_current_order ? 'success' : 'outline-success'">Yes</CButton>
                <CButton size="sm" @click="form.applies_to_current_order = false" style="margin-left:5px;" :color="!form.applies_to_current_order ? 'danger': 'outline-danger'">No</CButton>
              </div>

              <div style="padding-bottom:15px;">
                <label>Allow This Promotion To Stack With Prebook?</label>
                <CButton type="button" size="sm" @click="form.allows_stackable = true" style="margin-left:5px;" :color="form.allows_stackable ? 'success' : 'outline-success'">Yes</CButton>
                <CButton type="button" size="sm" @click="form.allows_stackable = false" style="margin-left:5px;" :color="!form.allows_stackable ? 'danger': 'outline-danger'">No</CButton>
              </div>

              <div v-if="form.allows_stackable" class="prebook-combinations">
                <div class="prebook-combinations-heading">
                  <div>
                    <label>Allowed Prebook Combinations</label>
                    <small>Select each prebook this promotion can stack with and enter its combined NetSuite internal ID.</small>
                  </div>
                  <CButton type="button" size="sm" color="primary" @click="addPrebookCombination">Add Combination</CButton>
                </div>
                <div v-for="(combination, index) in form.prebook_combinations" :key="index" class="prebook-combination-row">
                  <div>
                    <label>Prebook Option</label>
                    <v-select
                      v-model="combination.prebook_option"
                      :options="prebookOptions"
                      label="pre_book_label"
                      placeholder="Select Prebook Option"
                    />
                  </div>
                  <div>
                    <label>Combined NetSuite Internal ID</label>
                    <input class="form-control" v-model="combination.combined_with_promo_internal_id" />
                  </div>
                  <CButton class="combination-remove" type="button" size="sm" color="outline-danger" @click="removePrebookCombination(index)">Remove</CButton>
                </div>
                <div v-if="!form.prebook_combinations.length" class="prebook-combinations-empty">No prebook combinations have been added yet.</div>
              </div>
  
              <div style="width:100%;float:left;padding-bottom:15px;">
                <label>Programs This Applies To</label>
                <multiselect v-model="form.programs" :options="programs" :multiple="true" label="program_name" track-by="program_id" />
              </div>
  
              <div style="width:100%;float:left;padding-bottom:15px;">
                <label>Bonus Programs (if applicable)</label>
                <multiselect v-model="form.bonus_programs" :options="programs" :multiple="true" label="program_name" track-by="program_id" />
              </div>
  
              <div style="padding-bottom:15px;">
                <label>Upload New Promotion PDF (optional)</label>
                <input type="file" @change="handleFileUpload" />
                <div v-if="form.pdf">
                  <small>Current PDF: <a :href="form.pdf" target="_blank">View</a></small>
                </div>
              </div>
  
              <CInput label="Ends At" type="date" v-model="form.ends_at" />
            </CForm>
  
            <CButton class="mt-3" color="success" @click="save">Save</CButton>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </template>
  
  <script>
  import Multiselect from 'vue-multiselect';
  export default {
    name: 'EditPromotion',
    components: { Multiselect },
    data() {
      return {
        form: null,
        discountTypes: ['free_item', 'free_item_same_order', 'discount', 'per_unit_dollar_discount', 'free_locations', 'shipping_discount'],
        programs: [],
        userTypeOptions: [],
        shipViaOptions: [],
        techniqueTypeOptions: [],
        techniques: [],
        prebookOptions: [],
        productClasses: [],
        formLoaded: false,
        techniquesLoaded: false
      }
    },
    mounted() {
      this.loadPrograms();
      this.loadForm();
      this.getUserTypes();
      this.getShipViaOptions();
      this.getTechniqueTypes();
      this.getTechniques();
      this.getProductClasses();
      this.getPrebookOptions();
    },
    methods: {
      techniqueOptionLabel(technique) {
        if (!technique) return '';
        const programs = (technique.programs || [])
          .map(program => program.program_name)
          .filter(Boolean)
          .join(', ');
        const assignment = programs || 'No program assigned';
        return `${technique.technique_name} — ${assignment} (ID ${technique.technique_id})`;
      },
      normalizeTechniqueSelections() {
        if (!this.formLoaded || !this.techniquesLoaded || !this.form) return;
        let raw = this.form.technique_ids;
        if (typeof raw === 'string') {
          try {
            const parsed = JSON.parse(raw);
            raw = parsed;
          } catch (e) {
            raw = raw.split(',').map(s => s.trim()).filter(Boolean);
          }
        }
        if (!Array.isArray(raw)) {
          this.form.technique_ids = [];
          return;
        }

        const ids = new Set(
          raw.map(v => {
            if (typeof v === 'object' && v) return v.technique_id;
            const n = Number(v);
            return Number.isNaN(n) ? v : n;
          })
        );

        this.form.technique_ids = this.techniques.filter(t => ids.has(t.technique_id));
      },
      loadPrograms() {
        axios.get(this.$apiAdress + '/api/programs?token=' + localStorage.getItem("api_token"))
          .then(res => this.programs = res.data)
          .catch(console.error);
      },
      loadForm() {
        axios.get(`${this.$apiAdress}/api/promotions/${this.$route.params.id}?token=${localStorage.getItem("api_token")}`)
        .then(res => {
            this.form = res.data;
            if (!Array.isArray(this.form.technique_ids)) this.form.technique_ids = [];
            if (!Array.isArray(this.form.technique_types)) this.form.technique_types = [];
            if (!Array.isArray(this.form.product_classes)) this.form.product_classes = [];
            if (!Array.isArray(this.form.bonus_product_classes)) this.form.bonus_product_classes = [];
            if (!Array.isArray(this.form.user_types)) this.form.user_types = [];
            if (typeof this.form.allows_stackable === 'undefined') {
              this.$set(this.form, 'allows_stackable', false);
            }
            this.$set(this.form, 'prebook_combinations', (this.form.prebook_options || []).map(option => ({
              prebook_option: option,
              combined_with_promo_internal_id: option.pivot ? option.pivot.combined_with_promo_internal_id : ''
            })));
            this.formLoaded = true;
            this.normalizeTechniqueSelections();
        })
        .catch(err => {
            console.error(err);
        });
      },
      getProductClasses() {
        let self = this
        axios.post( this.$apiAdress + '/api/styles/getProductClasses?token=' + localStorage.getItem("api_token"))
        .then(function (response) {
          console.log(response)
          // self.programOptions = response.data
          var arr = []
          response.data.forEach(function (val) {
            arr.push(val.product_class)
          })
          self.productClasses = arr
        }).catch(function (error) {
          console.log(error)
        });
      },
      getUserTypes() {
        axios.get(this.$apiAdress + '/api/roles?token=' + localStorage.getItem('api_token')).then(response => {
          console.log(response)
          // this.roles = response.data
          var that = this
          this.userTypeOptions = []
          response.data.forEach(function (val) {
            that.userTypeOptions.push(val.name)
          })
        })
      },
      getShipViaOptions() {
        let self = this
        const postData = {
          type: 'all'
        }
        axios.post( this.$apiAdress + '/api/ship_vias/getOrderShipVias?token=' + localStorage.getItem("api_token"), postData)
        .then(function (response) {
          console.log(response)
          self.shipViaOptions = response.data
        }).catch(function (error) {
          console.log(error)
        });
      },
      getTechniqueTypes() {
        let self = this
        axios.get( this.$apiAdress + '/api/techniques/getTechniqueTypes?token=' + localStorage.getItem("api_token"))
        .then(function (response) {
          console.log(response)
          self.techniqueTypeOptions = response.data
        }).catch(function (error) {
          console.log(error)
        });
      },
      getTechniques() {
        axios.get(this.$apiAdress + '/api/techniques?token=' + localStorage.getItem("api_token"))
          .then(response => {
            this.techniques = response.data;
            this.techniquesLoaded = true;
            this.normalizeTechniqueSelections();
          })
          .catch(console.error);
      },
      getPrebookOptions() {
        axios.post(this.$apiAdress + '/api/getPrebookOptions?token=' + localStorage.getItem('api_token'))
          .then(response => this.prebookOptions = response.data)
          .catch(console.error);
      },
      addPrebookCombination() {
        if (!Array.isArray(this.form.prebook_combinations)) {
          this.$set(this.form, 'prebook_combinations', []);
        }
        this.form.prebook_combinations.push({
          prebook_option: null,
          combined_with_promo_internal_id: ''
        });
      },
      removePrebookCombination(index) {
        this.form.prebook_combinations.splice(index, 1);
      },
      handleFileUpload(event) {
        this.form.new_pdf = event.target.files[0];
      },
      save() {
        let formData = new FormData();

        Object.entries(this.form).forEach(([key, val]) => {
          if (key === 'prebook_options') return;

          if (key === 'prebook_combinations') {
            (val || []).forEach((combination, i) => {
              if (!combination.prebook_option) return;
              formData.append(`prebook_combinations[${i}][prebook_option_id]`, combination.prebook_option.id);
              formData.append(`prebook_combinations[${i}][combined_with_promo_internal_id]`, combination.combined_with_promo_internal_id);
            });
            return;
          }

          // SPECIAL CASE: ship_to_type is an object from v-select
          if (key === 'ship_to_type' && val && typeof val === 'object') {
            Object.entries(val).forEach(([k, v]) => {
              // e.g. ship_to_type[ship_via_code], ship_to_type[ship_via_text]
              formData.append(`ship_to_type[${k}]`, v);
            });
            return; // skip normal handling for ship_to_type
          }

          if (key === 'new_pdf' && val instanceof File) {
            formData.append('pdf', val);
          } else if (key === 'programs' || key === 'bonus_programs') {
            (val || []).forEach((item, i) => {
              formData.append(`${key}[${i}]`, item.program_id || item.id);
            });
          } else if ((key === 'product_classes' || key === 'bonus_product_classes') && Array.isArray(val)) {
            val.forEach((pc, i) => {
              formData.append(`${key}[${i}]`, pc);
            });
          } else if (key === 'user_types' && Array.isArray(val)) {
            val.forEach((ut, i) => {
              formData.append(`user_types[${i}]`, ut);
            });
          } else if (key === 'technique_types' && Array.isArray(val)) {
            val.forEach((ut, i) => {
              formData.append(`technique_types[${i}]`, ut);
            });
          } else if (key === 'technique_ids' && Array.isArray(val)) {
            val.forEach((id, i) => {
              const techniqueId = typeof id === 'object' ? id.technique_id : id;
              formData.append(`technique_ids[${i}]`, techniqueId);
            });
          } else if (val !== null && val !== undefined) {
            formData.append(key, val);
          }
        });
        axios.post(
          `${this.$apiAdress}/api/promotions/${this.$route.params.id}/update?token=${localStorage.getItem("api_token")}`,
          formData,
          { headers: { 'Content-Type': 'multipart/form-data' } }
        )
        .then(() => this.$router.push('/promotions'))
        .catch(err => {
          console.log(err.response.data);
          console.log(err.response.data.errors);
      });
      }
    }
  }
  </script>
  
  <style scoped>
  small {
    display: block;
    margin-top: 5px;
  }

  .prebook-combinations {
    clear: both;
    padding: 15px 0;
  }

  .prebook-combinations-heading {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 16px;
    margin-bottom: 12px;
  }

  .prebook-combinations-heading label {
    display: block;
    font-weight: 600;
    margin-bottom: 2px;
  }

  .prebook-combination-row {
    display: grid;
    grid-template-columns: minmax(280px, 2fr) minmax(220px, 1fr) auto;
    gap: 16px;
    align-items: end;
    margin-bottom: 12px;
    padding: 16px;
    border: 1px solid #d8dbe0;
    border-radius: 6px;
    background: #f8f9fa;
  }

  .prebook-combination-row label {
    font-weight: 600;
  }

  .combination-remove {
    margin-bottom: 0;
  }

  .prebook-combinations-empty {
    padding: 16px;
    color: #6c757d;
    text-align: center;
    border: 1px dashed #c8ced3;
    border-radius: 6px;
  }

  @media (max-width: 900px) {
    .prebook-combination-row {
      grid-template-columns: minmax(0, 1fr);
    }

    .combination-remove {
      justify-self: start;
      margin-bottom: 0;
    }
  }
  </style>
